import { gql } from '@zenbusiness/application-commons-graphql';

export const UPDATE_THREAD_TITLE_MUTATION = gql`
  mutation UpdateThreadTitle($identity: Identity!, $threadUuid: UUID!, $title: String!) {
    updateThreadTitle(identity: $identity, threadUuid: $threadUuid, title: $title) {
      ok
      threadUuid
      error
    }
  }
`;
